export { isSafeReportDownloadUrl } from '../../reports/lib/urlSafety';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

export function isSafeApiDownloadUrl(
  value: string | null | undefined,
): value is string {
  if (!value) return false;

  try {
    const url = new URL(value);
    if (url.username || url.password) return false;
    if (url.protocol === 'https:') return true;

    return url.protocol === 'http:' && LOCAL_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
}
